<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>
                <v-layout column align-end pb-2>
                    <v-flex xs4 class="text-xs-right">
                        <v-sheet color="primary" class="px-2 py-1 elevation-2" dark>
                            <v-icon left>mdi-airplane</v-icon>
                            <span>
                                {{ remaining }}/{{ allowance }} holidays remaining<br>
                                {{ pending }} pending holidays<br>
                                {{ confirmed }} confirmed holidays
                            </span>
                            <v-divider class="my-2"></v-divider>
                            <v-switch class="ma-0 pa-0 justify-end showAllToggle" v-model="showAll" color="white" label="All users"></v-switch>
                        </v-sheet>
                    </v-flex>
                </v-layout>
                <div class="container-cal-btns elevation-1">
                    
                    <v-layout row wrap>
                        <v-flex xs1 class="text-xs-left">
                            <v-btn @click="$refs.calendar.prev(); handleCalTitle('l');" color="primary" icon flat>
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex xs10 align-self-center class="text-xs-center cal-title">{{ calTitle }}
                        </v-flex>
                        <v-flex xs1 class="text-xs-right">
                            <v-btn @click="$refs.calendar.next(); handleCalTitle('r');" color="primary" icon flat>
                                <v-icon>chevron_right</v-icon>
                            </v-btn>
                        </v-flex>    
                    </v-layout>
                </div>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-sheet height="650" class="elevation-1">
                            <v-calendar ref="calendar" v-model="today" @click:date="dayClick" :value="today" :end="end" :weekdays="weekdays" :locale="locale" :type="type" :short-months="false" color="primary">
                                <template v-if="loadCal" v-slot:day="{ date }">
                                    <template v-for="holiday in holidaysMap[date]">
                                        <v-menu v-if="holiday.holidayId && holiday.user_id == userId" content-class="holiday-info" :key="holiday.holidayId" v-model="holiday.open" full-width offset-x>
                                            <template v-slot:activator="{ on }">
                                                <div :class="{ 'hol-am' : holiday.half_day == 'AM',
                                                               'hol-pm' : holiday.half_day == 'PM',
                                                               'pending' : holiday.status == 'Pending' && holiday.type == 'Holiday',
                                                               'confirmed' : holiday.status == 'Confirmed' && holiday.type == 'Holiday',
                                                               'declined' : holiday.status == 'Declined' && holiday.type == 'Holiday',
                                                               'sick-day' : holiday.type == 'Sick Day',
                                                               'compassionate' : holiday.type == 'Compassionate',
                                                               'business' : holiday.type != 'Sick Day' && holiday.type != 'Holiday' }"
                                                               v-ripple class="event" v-on="on" v-html="`${holiday.first_name} ${holiday.surname}`"></div>
                                            </template>
                                            <v-card color="white" min-width="350px" flat>
                                                <v-toolbar color="primary" dark>
                                                    <v-toolbar-title v-html="holiday.first_name"></v-toolbar-title>
                                                </v-toolbar>
                                                <v-card-title primary-title>
                                                    <div class="holiday-details-container">
                                                        <span class="holiday-details-title">Date:<span class="holiday-details">{{ prettyDatetime(holiday.date) }}</span></span>
                                                        
                                                        <span class="holiday-details-title">Type:<span class="holiday-details">{{ holiday.type }}</span></span>
                                                        
                                                        <span class="holiday-details-title">Requested Date:<span class="holiday-details">{{ prettyDatetime(holiday.requested_date) }}</span></span>
                                                        
                                                        <span class="holiday-details-title">Description:<span class="holiday-details">{{ holiday.description }}</span></span>

                                                        <span class="holiday-details-title">Status:<span class="holiday-details">{{ holiday.status }}</span></span>

                                                        <span v-if="holiday.half_day" class="holiday-details-title">Half Day:<span v-if="holiday.half_day" class="holiday-details">{{ holiday.half_day }}</span></span>

                                                        <span v-if="holiday.authorised_by" class="holiday-details-title">Authorised By:<span class="holiday-details">{{ holiday.authorised_by }}</span></span>

                                                        <span v-if="holiday.authorisation_date" class="holiday-details-title">Authorisation Date:<span class="holiday-details">{{ holiday.authorisation_date }}</span></span>
                                                    </div>         
                                                </v-card-title>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn @click="deleteHoliday(holiday)" color="error">Delete</v-btn>
                                                    <v-btn color="primary">Ok</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-menu>

                                        <div v-else-if="holiday.holidayId && holiday.user_id != userId && showAll" :key="holiday.holidayId"
                                              :class="{ 'hol-am' : holiday.half_day == 'AM',
                                                        'hol-pm' : holiday.half_day == 'PM',
                                                        'pending' : holiday.status == 'Pending' && holiday.type == 'Holiday',
                                                        'confirmed' : holiday.status == 'Confirmed' && holiday.type == 'Holiday',
                                                        'declined' : holiday.status == 'Declined' && holiday.type == 'Holiday',
                                                        'sick-day' : holiday.type == 'Sick Day',
                                                        'compassionate' : holiday.type == 'Compassionate',
                                                        'business' : holiday.type != 'Sick Day' && holiday.type != 'Holiday' }"
                                                        v-ripple class="event" v-html="`${holiday.first_name} ${holiday.surname}`">
                                        </div>
                                       
                                        <v-sheet v-else :key="holiday.id" class="bank-holiday">{{ holiday.holiday }}</v-sheet>
                                    </template>
                                </template>
                            </v-calendar>
                        </v-sheet>
                    </v-flex>
                    <v-flex xs6>
                        <v-dialog v-model="bookingDialog" max-width="400">
                            <v-card>
                                <v-toolbar dark color="primary">
                                    <v-toolbar-title>Book Holiday</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>

                                <div class="booking-data pa-3">
                                    <v-flex xs12>
                                        <v-select v-model="holidayType" dense :items="typeOptions" label="Type"></v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-dialog ref="fromDateDialog" v-model="fromDateModal" :return-value.sync="fromDate" persistent lazy full-width width="290px">
                                            <v-text-field slot="activator" v-model="fromDate" label="From Date" append-icon="event" readonly></v-text-field>
                                            <v-date-picker v-model="fromDate" :allowed-dates="allowedDates" :first-day-of-week="1" scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn flat color="primary" @click="fromDateModal = false">Cancel</v-btn>
                                                <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select v-model="fromDateStart" dense :items="fromDateStartOptions" label="From" append-icon="search"></v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-dialog ref="toDateDialog" v-model="toDateModal" :return-value.sync="toDate" persistent lazy full-width width="290px">
                                            <v-text-field slot="activator" v-model="toDate" label="To Date" append-icon="event" readonly></v-text-field>
                                            <v-date-picker v-model="toDate" :allowed-dates="allowedDates" :first-day-of-week="1" scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn flat color="primary" @click="toDateModal = false">Cancel</v-btn>
                                                <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select v-model="toDateStart" dense :items="toDateStartOptions" label="To" append-icon="search"></v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field v-model="description" append-icon="search" label="Description" clearable></v-text-field>
                                    </v-flex>
                                </div>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary lighten-2" @click="bookingDialog = false">Cancel</v-btn>
                                    <v-btn color="primary" @click="bookingDialog = false; bookHoliday()">Create</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template> 

<script>
    import sweetAlert from '../sweetAlert.js';
    import axios from 'axios';
    import moment from 'moment';

    export default {
        data () {
            return {
                userId: localStorage.user_id,
                type: 'month',
                locale: 'en-gb',
                today: new Date().toJSON().slice(0,10).replace(/-/g,'-'),
                end: '2022-01-01',
                weekdays: [1, 2, 3, 4, 5, 6, 0],
                bookingDialog: false,
                fromDate: new Date().toISOString().substr(0, 10),
                toDate: new Date().toISOString().substr(0, 10),
                fromDateModal: false,
                toDateModal: false,
                holidayType: "Holiday",
                typeOptions: [
                            { value: "Compassionate", text: "Compassionate" },
                            { value: "Event", text: "Event" },
                            { value: "Holiday", text: "Holiday" },
                            { value: "Meeting", text: "Meeting" },
                            { value: "Sick Day", text: "Sick Day" },
                            { value: "Training", text: "Training" }
                ],
                fromDateStartOptions: [ { value: 0, text: 'Beginning of the day'},
                                        { value: 1, text: 'Middle of the day'} ],
                toDateStartOptions: [ { value: 0, text: 'Middle of the day'},
                                      { value: 1, text: 'End of the day'} ],
                fromDateStart: 0,
                toDateStart: 1,
                description: null,
                holidays: null,
                holidaysMap: {},
                bankHolidays: null,
                loadCal: false,
                calTitle: moment().format('MMMM YYYY'),
                bookingDates: null,
                allowance: '0.0',
                remaining: '0.0',
                pending: '0.0',
                confirmed: '0.0',
                showAll: true
            }
        },
        beforeMount() {
            this.getHolidayAllowance();
            this.getHoliday();
            this.getBankHolidays();
            console.log(this.holidaysMap);
        },
        computed: {
            showAllToggle() {
                // return this.showAll ? 'All Users' : 'User';
            }
        },
        methods: {
            open(event) {
                // alert(event.title)
            },
            dayClick(e) {
                const now = moment(new Date());
                const date = moment(e.date);
                const diff = moment(moment(e.date)).diff(new Date(), 'days');
                this.toDate = e.date;
                this.fromDate = e.date;
                
                if(diff >= -7 && this.remaining > 0) {
                    if(!this.bankHolidays.some(row => row.date.includes(e.date)) && date.day() != 6 && date.day() != 0) {
                        if(!this.holidaysMap[e.date]) {
                            this.bookingDialog = true;
                        }
                        else {
                            if(!this.holidaysMap[e.date].some(row => row.user_id == this.userId)) {
                                this.bookingDialog = true;
                            }
                        }
                    }
                }
            },
            handleDateChange() {
                if(this.toDate < this.fromDate) {
                    this.fromDate = this.toDate;
                }
                this.$refs.fromDateDialog.save(this.fromDate);
                this.$refs.toDateDialog.save(this.toDate);
            },
            allowedDates: val => val > moment().subtract(8, "days").format('YYYY-MM-DD'),
            createMap(data) {
                if(data) {
                    this.loadCal = false;
                    // data.forEach(e => (this.holidaysMap[e.date] = this.holidaysMap[e.date] || []).push(e));
                    data.forEach((e) => {
                        if(!this.holidaysMap[e.date]) {
                            (this.holidaysMap[e.date] = this.holidaysMap[e.date] || []).push(e);
                        }
                        else {
                            this.holidaysMap[e.date].filter(row => {
                                if(!this.holidaysMap[e.date].some(row => row.holidayId == e.holidayId)) {
                                    (this.holidaysMap[e.date] = this.holidaysMap[e.date] || []).push(e);
                                }
                            })
                        }
                    })
                    this.loadCal = true;
                }
            },
            bookHoliday() {

                let i = 0;
                const from = this.fromDate;
                let halfDay = null;
                this.bookingDates = [];

                while(moment(this.fromDate, "YYYY-MM-DD").add(i, 'days').format('YYYY-MM-DD') <= this.toDate) {

                    if(i == 0 && this.fromDate != this.toDate) {
                        halfDay = this.fromDateStart == 1 ? 'PM' : null;
                    }
                    else if(i == 0 && this.fromDate == this.toDate) {
                        halfDay = this.fromDateStart == 0 && this.toDateStart == 0 ? 'AM' :
                                  this.fromDateStart == 1 && this.toDateStart == 1 ? 'PM' : null;
                    }
                    else if(moment(this.fromDate, "YYYY-MM-DD").add(i, 'days').format('YYYY-MM-DD') == this.toDate) {
                        halfDay = this.toDateStart == 1 ? null : 'AM';
                    }
                    else {
                        halfDay = null;
                    }

                    if(!this.holidaysMap[moment(this.fromDate, "YYYY-MM-DD").add(i, 'days').format('YYYY-MM-DD')]
                    || this.holidaysMap[moment(this.fromDate, "YYYY-MM-DD").add(i, 'days').format('YYYY-MM-DD')].filter(row => row.user_id != this.userId) ) {
                        let data = { 'userId': localStorage.user_id,
                                 'date': moment(this.fromDate, "YYYY-MM-DD").add(i, 'days').format('YYYY-MM-DD'),
                                 'type': this.holidayType,
                                 'halfDay': halfDay,
                                 'description': this.description
                               };

                        this.bookingDates.push(data);
                    }
                    i++;
                }
                
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/book-holiday',
                data: { bookingDates: this.bookingDates, userId: localStorage.user_id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.getHoliday();
                    this.allowance = response.data.allowance;
                    this.remaining = response.data.remaining;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            deleteHoliday(holiday) {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/delete-holiday',
                data: { id: holiday.holidayId, userId: localStorage.user_id, halfDay: holiday.half_day, status: holiday.status, type: holiday.type },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {                 
                    this.loadCal = false;
                    
                    if(this.holidaysMap[holiday.date].length > 1) {
                        this.holidaysMap[holiday.date].map((row, i) => {
                            if(row.holidayId == holiday.holidayId) {
                                this.holidaysMap[holiday.date].splice(i, 1);
                            }
                        });
                    }
                    else {
                        delete this.holidaysMap[holiday.date];
                    }
                    this.loadCal = true;
                    this.allowance = response.data.allowance;
                    this.remaining = response.data.remaining;
                    this.pending = holiday.status == 'Pending' ? this.pending - 1 : this.pending;
                    this.confirmed = holiday.status == 'Confirmed' ? this.confirmed - 1 : this.confirmed;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            async getHoliday() {
                try {
                    this.holidays = await axios({
                    method: 'post',
                    url: 'https://controlapi.totalprocessing.com/api/get-holiday',
                    data: { userId: localStorage.user_id },
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        // console.log(response.data);
                        this.pending = response.data.filter(row => row.user_id == this.userId && row.status == 'Pending' && row.date > moment().format('YYYY-MM-DD')).length;
                        this.confirmed = response.data.filter(row => row.user_id == this.userId && row.status == 'Confirmed' && row.date > moment().format('YYYY-MM-DD')).length;
                        return response.data;
                    })
                    .catch(e => {
                        this.errors.push(e)
                    })
                    this.createMap(this.holidays);
                }
                catch(e) {
                    console.log(e)
                }
            },
            async getBankHolidays() {
                try {
                    this.bankHolidays = await axios({
                    method: 'get',
                    url: 'https://controlapi.totalprocessing.com/api/get-bank-holidays',
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        return response.data;
                    })
                    .catch(e => {
                        this.errors.push(e)
                    })
                    this.createMap(this.bankHolidays);
                }
                catch(e) {
                    console.log(e)
                }
            },
            handleCalTitle(e) {
                const date = moment(this.calTitle, 'MMMM YYYY').format('YYYY-MM-DD');

                if(e == 'l') {
                    this.calTitle = moment(date).subtract(1, 'months').format('MMMM YYYY');
                }
                else {
                    this.calTitle = moment(date).add(1, 'months').format('MMMM YYYY');
                }
            },
            prettyDatetime(date) {
                return moment(date).format('Do MMMM YYYY, hh:mm:ss');
            },
            getHolidayAllowance() {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/get-holiday-allowance',
                data: { userId: localStorage.user_id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.allowance = response.data.allowance;
                    this.remaining = response.data.remaining;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        }
    }
</script>

<style>
    .container-cal-btns {
        padding: 10px;
        margin-bottom: 10px;
    }

    .container-cal-btns button,
    .container-cal-btns .flex {
        margin: 0;
        padding: 0 !important;
    }

    .cal-title {
        color: #1867c0;
        font-weight: 600;
    }

    .v-calendar-weekly__head {
        border-bottom: 1px solid #e0e0e0 !important;
    }

    .v-calendar-weekly__head > .v-calendar-weekly__head-weekday {
        padding: 5px !important;
        font-weight: 600 !important;
    }

    .event {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        border-radius: 2px;
        width: 100%;
        font-size: 12px;
        padding: 3px;
        cursor: pointer;
        padding: 0px;
        margin-bottom: 2px;
        margin-top: 0px;
    }

    .v-calendar-weekly__day > .event:nth-child(2) {
        margin-top: 2px !important;
    }

    .pending {
        color: #1867c0;
        background: none;
        border: 1px solid #1867c0;
    }

    .confirmed {
        color: #ffffff;
        background-color: #1867c0;
        border: 1px solid #1867c0;
    }

    .declined {
        color: #ffffff;
        background-color: #f44336;
        border: 1px solid #f44336;
    }

    .business {
        color: #ffffff;
        background-color: #607D8B;
        border: 1px solid #607D8B;
    }

    .sick-day {
        color: #ffffff;
        background-color: #66BB6A;
        border: 1px solid #66BB6A;
    }

    .compassionate {
        color: #ffffff;
        background-color: #F48FB1;
        border: 1px solid #F48FB1;
    }

    .hol-am {
        width: 50%;
        clear: both;
    }

    .hol-pm {
        width: 50%;
        float: right;
        clear: both;
    }

    .v-calendar-weekly__day-month {
        font-weight: 600;
        color: #1867c0;
    }

    .v-outside div {
        display: none;
    }

    .holiday-details-container {
        text-align: left;
    }

    .holiday-details-title {
        display: block;
        font-weight: 600;
    }

    .holiday-details {
        font-weight: 400;
        margin-left: 5px;
    }

    .holiday-info {
        position: absolute;
        left: 50% !important;
        top: 50% !important;
        -webkit-transform: translate(-50%, -50%) !important;
        transform: translate(-50%, -50%) !important;
    }

    .v-past {
        background-color: #f7f7f7;
    }

    .bank-holiday {
        color: #1867c0 !important;
        font-weight: 600;
        background: none !important;
        position: absolute !important;
        height: 20px;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }

    .showAllToggle .v-input__slot {
        margin: 0 !important;
    }

    .showAllToggle .v-label {
        font-size: 14px !important;
        color: #fff !important;
    }

    .showAllToggle .v-input__control {
        height: 25px;
    }
</style>
